import { render, staticRenderFns } from "./CollapsableCardWithHeader.vue?vue&type=template&id=0e1a56b8&scoped=true"
import script from "./CollapsableCardWithHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsableCardWithHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CollapsableCardWithHeader.vue?vue&type=style&index=0&id=0e1a56b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a56b8",
  null
  
)

export default component.exports